import $ from 'jquery';

function initializeButtonDisable() {
    let $button = $('.signup-btn');
    $button.on('click', () => {
      $button.addClass('disabled') ;
    });

}

export default initializeButtonDisable;
